/**
 * Configuración del footer. Puede reemplazarse por datos de API si se dispone.
 */
export const footerConfig = {
  facebook: "https://www.facebook.com/HospitalBritanico",
  twitter: "https://twitter.com/HospitalBritanico",
  linkedin: "https://www.linkedin.com/company/hospital-britanico",
  instagram: "https://www.instagram.com/hospitalbritanico",
  intranet: "https://intranet.hbritanico.com.ar",
  direccion_domicilio: "Perdriel 74, CABA",
  telefono_domicilio: "4129-7400",
  ubicacion: "https://www.google.com/maps?q=Perdriel+74+CABA",
  titulo_politicas: "Política de Protección de Datos Personales",
  titulo_terminos: "Términos y Condiciones",
};
